"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immutable_1 = require("immutable");
const ModificationRequestIssueComment_1 = require("./ModificationRequestIssueComment");
class ModificationRequestIssue {
    constructor({ id, name, comments, resolved, }) {
        this.toJSON = () => ({
            id: this.id,
            name: this.name,
            comments: this.comments.toJSON(),
            resolved: this.resolved,
        });
        this.id = id;
        this.name = name;
        this.comments = comments;
        this.resolved = resolved;
    }
}
ModificationRequestIssue.fromJSON = (json) => {
    const { id, name, comments, resolved } = Object.assign({}, json);
    if (typeof id !== 'string')
        throw new Error('.id must be a string');
    if (typeof name !== 'string')
        throw new Error('.name must be a string');
    if (typeof resolved !== 'boolean')
        throw new Error('.resolved must be a string');
    return new ModificationRequestIssue({
        id,
        name,
        // FIXME: ModificationRequestIssueComment.fromJSONを呼ばれると、commentの assetIds をArrayで渡さないとバリデーションで弾かれるが、
        // commentのインスタンス化はListからしかできないのでコンパイルが通らない => ModificationRequestIssue は fromJSON 経由でインスタンス化できない
        comments: immutable_1.List(comments).map(comment => ModificationRequestIssueComment_1.default.fromJSON(comment)),
        resolved,
    });
};
exports.default = ModificationRequestIssue;
